var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionSubscriptionInfo } from "./actionSubscriptionInfo";
var initial = {
    subscriptions: [],
};
export var reducerSubscriptionInfo = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionSubscriptionInfo.Update && action.subscriptionInfo != undefined) {
        return __assign({}, state, action.subscriptionInfo);
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/subscription/reducerSubscriptionInfo.ts
// module id = 2543
// module chunks = 3